module.exports = __webpack_public_path__ + "img/cuff_width.768e5261.png";